import { Component, ElementRef, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {EnvironmentService} from "../../_services/environment.service";



@Component({
    selector: 'app-Newsletters',
    templateUrl: './Newsletters.component.html',
    styleUrls: ['./Newsletters.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})



export class NewslettersComponent implements OnInit {
  status=false;
  open=true;
  // load: any;
  constructor(public envService: EnvironmentService, private renderer: Renderer2) {
    // this.load=new Promise((resolve) => {
    //   this.loadFile();

    // })
  }
  // loadFile(){
  //   let node=document.createElement('script');
  //   node.src='//lacounty.us11.list-manage.com/generate-js/?u=3d79962a0e2ac6a48c94d04e8&fid=12718&show=10';
  //   node.type='text/javascript';
  //   node.async=false;
  //   node.charset='utf-8';
  //   document.getElementsByTagName('i')[0].appendChild(node);
  // }



  @ViewChild('govDeliverySignup', { static: true })
  govDeliverySignup!: ElementRef;

  ngOnInit() {
    const script = document.createElement('script');

    script.src="https://public.govdelivery.com/assets/Signup.js";
    script.async = true;
    script.setAttribute('data-account-code', 'CALACOUNTY');
    script.setAttribute('data-signup-id', '50489');

    this.govDeliverySignup.nativeElement.appendChild(script);
  }

}
